import Vue from "vue";
export const bus = new Vue();



// WEBPACK FOOTER //
// ./src/gtn/views/financialCompetitionViews/config.js